<template>
  <div data-tilt class="backgroundLegitrans" id="background1">
    <div data-tilt class="transbox" id="transbox1">
      <h1 class="pulse">Legitrans</h1>
      <br>
      <p>Actualmente somos referencia en nuestra provincia.</p>

      <p>Nuestra empresa presta un servicio integral al medioambiente.</p> 

      <p>Servicios habituales:</p>
      <br>
      <ul>
        <li>Recogida de residuos (Aceite, Amianto, Talleres, Industrias, ...).</li>
        <li>Transporte de <u>residuos peligrosos y no peligrosos</u> de todos los códigos LER.</li>
        <li>Analíticas.</li>
        <li>Bañeras y cisternas.</li>
        <li>Contenedores de gran volumen.</li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Legitrans',
  props: {
    msg: String
  }
}
</script>

<style scoped>
h3 {
  margin: 40px 0 0;
}
li{
  margin: 0 40px 0;
}
a {
  color: #42b983;
}

div.backgroundLegitrans {
  padding-left: 5%;
  padding-right: 5%;
  padding-top: 5px;
  padding-bottom: 5px;
  min-width: 800px;

}

div.transbox {
   margin: 30px;
  padding : 5%;
  font-family: Arial, Helvetica, sans-serif;
  text-align: justify;
  background: linear-gradient(300deg, rgb(27, 94, 32, 0.8) 0%, rgba(144,238,144,0.8) 50%, rgb(255, 255, 255, 0.8) 100%);
  box-shadow: 10px 10px 5px 0px rgba(0,0,0,0.75);
  border-radius: 15px;
  animation-name: opacity1;
  animation-duration: 1000ms;
  transform-origin:70% 70%;
  animation-iteration-count: initial;
  animation-timing-function: linear;
  min-width: 750px;
}

div {
  font-size: 30px;
}
.animation{
  animation-name: opacity1;
  animation-duration: 1500ms;
  transform-origin:70% 70%;
  animation-iteration-count: initial;
  animation-timing-function: linear;
}

@keyframes opacity1 {
  0% {
        display: none;
        opacity: 0;
    }

    1% {
        display: block;
        opacity: 0;
    }

    100% {
        display: block;
        opacity: 0.8;
    }
}

.animation1 {
    animation-name: animation1;
    animation-duration: 5000ms;
    transform-origin:100% 70%;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
}

@keyframes animation1 {
  0% { transform: rotateZ(0deg); }
  25% { transform: rotateZ(1deg); }
  50%{transform: rotateZ(0deg);}
  75%{transform: rotateZ(-1deg);}
  100% { transform: rotateZ(0deg); }
}

.animation2:hover {
  animation: animation2 0.82s cubic-bezier(.36,.07,.19,.97) both;
  transform: translate3d(0, 0, 0);
}
@keyframes animation2 {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }
  
  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }

  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
}

.animation3:hover {
    animation-name: animation3;
    animation-duration: 5000ms;
    transform-origin:100% 70%;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
}

@keyframes animation3 {
  0% { transform: rotateX(0deg); }
  50%{transform: rotateX(180deg);
  }
  100% { transform: rotateX(360deg); }
}

.animation4 {
    animation-name: animation4;
    animation-duration: 5000ms;
    transform-origin:100%;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
}

@keyframes animation4 {
  0% { transform: rotateY(0deg); }
  50%{transform: rotateY(10deg);}
  100% { transform: rotateY(0deg); }
}

.pulse:hover {
    animation-name: pulse_animation1;
    animation-duration: 5000ms;
    transform-origin:0% 70%;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
}

@keyframes pulse_animation1 {
  0% { transform: scale(1); }
  50% { transform: scale(1.2); }
  100% { transform: scale(1); }
}

</style>